import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { authService } from "../services/authService";
import "./Login.css";

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPageTurning, setIsPageTurning] = useState(false);
  const [registrationsEnabled, setRegistrationsEnabled] = useState(true);
  const [checkingRegistrations, setCheckingRegistrations] = useState(true);
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsPageTurning(true);
    const timer = setTimeout(() => setIsPageTurning(false), 600);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    const check = async () => {
      try {
        const data = await authService.getRegistrationsSetting();
        setRegistrationsEnabled(!!data.registrations_enabled);
      } catch {
        setRegistrationsEnabled(true);
      } finally {
        setCheckingRegistrations(false);
      }
    };
    check();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!registrationsEnabled) {
      setError("New user registrations are currently disabled");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);

    const result = await register(username, email, password);

    if (result.success) {
      navigate("/exams");
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <Link to="/" className="logo-link">
        <img src="/logos/examcat_logo.png" alt="Examcat" className="logo" />
      </Link>
      <div className={`book-container ${isPageTurning ? "page-turning" : ""}`}>
        <div className="book-left-page">
          <div className="notebook-lines">
            {Array.from({ length: 20 }).map((_, i) => (
              <div key={i} className="notebook-line"></div>
            ))}
          </div>
        </div>
        <div className="book-spine"></div>
        <div className="book-right-page">
          <div className="auth-form-container">
            <h2>Sign Up</h2>
            {checkingRegistrations ? (
              <p>Checking registration availability...</p>
            ) : !registrationsEnabled ? (
              <>
                <div className="error-message">
                  New user registrations are currently disabled. Please try
                  again later.
                </div>
                <p className="register-link">
                  Already have an account? <Link to="/login">Sign in here</Link>
                </p>
              </>
            ) : (
              <>
                {error && <div className="error-message">{error}</div>}
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="username">Username:</label>
                    <input
                      type="text"
                      id="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password:</label>
                    <input
                      type="password"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={loading}
                      minLength={6}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirmPassword">Confirm Password:</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      disabled={loading}
                      minLength={6}
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="submit-button"
                  >
                    {loading ? "Registering..." : "Sign Up"}
                  </button>
                </form>
                <p className="register-link">
                  Already have an account? <Link to="/login">Sign in here</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
